import { memo } from "react"
import { makeStyles } from "tss-react/mui"
import { Close } from "@mui/icons-material"
import { Grid, IconButton } from "@mui/material"
import { StandardDialog } from "../../../../../../shared/components/dialogs/StandardDialog"

const fallbackSvgUrl = `data:image/svg+xml;base64,${btoa(
    `<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="image-slash" class="svg-inline--fa fa-image-slash fa-3x css-1osx8r7-uploadIcon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" style="color: lightgray;"><path fill="currentColor" d="M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM576 96c0-35.3-28.7-64-64-64H139.6l40.5 32H512c17.7 0 32 14.3 32 32V265.4l-67.7-67.7c-15.6-15.6-40.9-15.6-56.6 0l-31 31 25.3 20 28.4-28.4c3.1-3.1 8.2-3.1 11.3 0L544 310.6v40.7l32 25.3V96zM297.6 319.8l-9.6 9.6-67.7-67.7c-15.6-15.6-40.9-15.6-56.6 0L96 329.4V160.7L64 135.4V416c0 35.3 28.7 64 64 64H500.4l-40.5-32H214.6L322.8 339.8l-25.3-20zM265.4 352l-96 96H128c-17.7 0-32-14.3-32-32V374.6l90.3-90.3c3.1-3.1 8.2-3.1 11.3 0L265.4 352z"></path></svg>`,
)}`

const useStyles = makeStyles()((_theme) => ({
    dialogContainer: {
        position: "relative",
        "& >img": {
            width: "100%",
            height: "auto",
            objectFit: "cover",
        },
    },
    previewPaperSlot: {
        overflow: "hidden",
    },
    hideEdge: { display: "none" },
}))

export const defaultPreviewProductImageState = { show: false, image: "" }
export type DefaultPreviewProductImageStateType = Readonly<{ show: boolean; image: string }>

type PreviewProductImageProps = Readonly<{
    previewImage: DefaultPreviewProductImageStateType
    setPreviewImage: React.Dispatch<React.SetStateAction<DefaultPreviewProductImageStateType>>
}>

export const PreviewProductImage = memo(({ previewImage, setPreviewImage }: PreviewProductImageProps) => {
    const { classes } = useStyles()

    return (
        <>
            <StandardDialog
                open={previewImage.show}
                onClose={() => setPreviewImage(defaultPreviewProductImageState)}
                updateEdge={classes.hideEdge}
                slotProps={{
                    paper: { className: classes.previewPaperSlot },
                }}
            >
                <Grid container className={classes.dialogContainer}>
                    <img
                        src={`${previewImage.image}`}
                        alt="product image"
                        onError={() =>
                            setPreviewImage((prev) => {
                                return { ...prev, image: fallbackSvgUrl }
                            })
                        }
                    />
                </Grid>
            </StandardDialog>
        </>
    )
})
